// Public by design. The key ships in the client bundle, and MUI recommends hardcoding it over an env var.
// https://mui.com/x/introduction/licensing/#environment-variable-with-next-js
export const MUI_X_LICENSE_KEY =
	'763a426f52017dc4f1b82372497bdac8Tz0xMzM2NDUsRT0xODIyOTUzNTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MixBVD1zaW5nbGUsS1Y9Mg==';
